import React, { Component } from 'react';
import PropTypes from 'prop-types';

import APIHandler from 'config/APIHandler';

import { appContentUrl } from 'settings';


export default class WebsiteSplitter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      websites: [],
    };
  }

  // Accepts salescompanion ID and toolbox type (as get parameters)
  componentDidMount() {
    const { itemID, type, appID } = this.props;
    APIHandler[`get${type[0].toUpperCase() + type.slice(1)}`](appID)
      .then((res) => {
        const { url } = res.filter(obj => obj.type === 'multi' && +obj.itemID === +itemID)[0];
        const websites = url.split('+').map((site) => {
          const [imageName] = site.match(/[^.:/]+(?=\.([a-z/-])+$)/gi); // NOTE: https://regexr.com/44q8i
          const image = `${appContentUrl}${window.appId}/${imageName}.png`;
          return {
            image, url: site, imageName,
          };
        });
        this.setState({ websites });
      });
  }

  render() {
    const { websites } = this.state;
    const { itemID } = this.props;

    return (
      <div className="wrapper__websiteButtons" id={itemID} style={{ display: 'none' }}>
        <div className="container__websiteButtons">
          {websites.length > 0 && websites.map(({ image, url, imageName }) => ((
            <a href={url} target="_blank" rel="noopener noreferrer" key={`${image}_${url}`}>
              <button className="button__website">
                <img src={image} alt={imageName} />
                <p>{url}</p>
              </button>
            </a>
            )))}
        </div>
      </div>
    );
  }
}

WebsiteSplitter.propTypes = {
  type: PropTypes.string.isRequired,
  itemID: PropTypes.string.isRequired,
  appID: PropTypes.number.isRequired,
};
